<template>
  <div>
    <base-header class="pb-6">
      <div class="row align-items-center py-4">
        <div class="col-lg-6 col-7">
          <h6 class="h2 d-inline-block mb-0">
            {{ $t("profile.change_pass") }}
          </h6>
          <nav aria-label="breadcrumb" class="d-none d-md-inline-block ml-md-4">
            <route-breadcrumb />
          </nav>
        </div>
      </div>
    </base-header>

    <div class="container-fluid mt--6">
      <div class="card mb-4">
        <!-- Card header -->
        <div class="card-header">
          <h3 class="mb-0">{{ $t("profile.change_pass") }}</h3>
        </div>
        <!-- Card body -->
        <div class="card-body">
          <!-- Form groups used in grid -->

          <form>
            <div class="form-group row">
              <label for="password-old" class="col-md-2 col-form-label form-control-label">{{
                $t("profile.pass_old")
              }}</label>
              <div class="col-md-10">
                <base-input id="password-old" type="password" placeholder="" v-model="password.old"></base-input>
              </div>
            </div>

            <div class="form-group row">
              <label
                for="password-new"
                class="col-md-2 col-form-label form-control-label"
                >{{ $t("profile.pass_new") }}</label
              >
              <div class="col-md-10">
                <base-input
                  id="password-new"
                  type="password"
                  autocomplete=""
                  placeholder=""
                  v-model="password.new"
                />
              </div>
            </div>

            <div class="form-group row">
              <label
                for="password_confirm"
                class="col-md-2 col-form-label form-control-label"
                >{{ $t("profile.pass_confirm") }}</label
              >
              <div class="col-md-10">
                <base-input
                  type="password"
                  autocomplete=""
                  placeholder=""
                  id="password_confirm"
                  v-model="password.confirm"
                />
              </div>
            </div>

            <div class="form-group row">
              <div class="offset-md-2 col-md-10">
                <base-button type="primary" @click="handleUpdate()">{{
                  $t("save")
                }}</base-button>
              </div>
            </div>
          </form>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { Table, TableColumn, Select, Option } from "element-ui";
import swal from "sweetalert2";
import { mapGetters, mapActions } from "vuex";

export default {
  name: "CreateNumber",
  components: {
    [Select.name]: Select,
    [Option.name]: Option,
    [Table.name]: Table,
    [TableColumn.name]: TableColumn
  },
  computed: {
    ...mapGetters({
      isCorporateAdmin: "Auth/isCorporateAdmin",
      isDtacAdmin: "Auth/isDtacAdmin",
      isReadOnly: "Auth/isReadOnly",
      corporate: "Corporate/getData"
    })
  },
  data() {
    return {
      optionChargeNumber: [
        {
          label: this.$t("menu.pilot_number"),
          value: 1
        },
        {
          label: this.$t("menu.agent_number"),
          value: 2
        }
      ],

      password: {
        old: "",
        new: "",
        confirm: ""
      }
    };
  },
  mounted() {
    this.listCorporate();
  },
  methods: {
    ...mapActions("Auth", ["changePassword"]),

    handleUpdate() {
      this.changePassword(this.password)
        .then(resp => {
          console.log(resp);
          swal
            .fire({
              title: this.$t("profile.change_pass_success"),
              text: ``,
              icon: "success",
              confirmButtonClass: "btn btn-success btn-fill",
              buttonsStyling: false
            })
            .then(result => {
              this.$router.push({ name: "agent_number" });
            });
        })
        .catch(err => {
          swal.fire({
            title: this.$t("errors.profile.change_pass_failed"),
            text: this.getErrorText(err.response.data),
            icon: "error",
            confirmButtonClass: "btn btn-danger btn-fill",
            buttonsStyling: false
          });
        });
    }
  }
};
</script>

<style scoped>
.form-group {
  margin-bottom: 0.2rem !important;
}
</style>
